import script from "./VTableTrTotal.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableTrTotal.vue?vue&type=script&setup=true&lang=js"

import "./VTableTrTotal.vue?vue&type=style&index=0&id=e0c8bfca&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0c8bfca"]])

export default __exports__